var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topMenuWrapper"},[(_vm.role != 'Extern')?_c('Menubar',{attrs:{"model":_vm.items}},[_c('SearchOrders'),_vm._v(" "),_c('VismaStatus'),_vm._v(" "),_c('UserMenu')],1):_c('Menubar',{attrs:{"model":_vm.externalItems}},[_c('SearchOrders'),_vm._v(" "),_c('UserMenu')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-573d79f7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Menus/TopMenu.vue
// module id = null
// module chunks = 